import React from "react";
import { Link } from "react-router-dom";

export default class FeatureFive extends React.Component {
  componentDidMount() {
    const $ = window.$;

    if ($(".tabs-box").length) {
      $(".tabs-box .tab-buttons .tab-btn").on("click", function (e) {
        e.preventDefault();
        var target = $($(this).attr("data-tab"));

        if ($(target).is(":visible")) {
          return false;
        } else {
          target
            .parents(".tabs-box")
            .find(".tab-buttons")
            .find(".tab-btn")
            .removeClass("active-btn");
          $(this).addClass("active-btn");
          target
            .parents(".tabs-box")
            .find(".tabs-content")
            .find(".tab")
            .fadeOut(0);
          target
            .parents(".tabs-box")
            .find(".tabs-content")
            .find(".tab")
            .removeClass("active-tab");
          $(target).fadeIn(300);
          $(target).addClass("active-tab");
        }
      });
    }

    if ($(".feature-three__history-carousel").length) {
      $(".feature-three__history-carousel").owlCarousel({
        loop: false,
        margin: 30,
        nav: false,
        smartSpeed: 500,
        autoHeight: false,
        autoplay: true,
        dots: false,
        autoplayTimeout: 6000,
        navText: [
          '<i className="fa fa-angle-double-left" aria-hidden="true"></i>',
          '<i className="fa fa-angle-double-right" aria-hidden="true"></i>',
        ],
        responsive: {
          0: {
            items: 1,
          },
          600: {
            items: 1,
          },
          992: {
            items: 2,
          },
          1200: {
            items: 3,
          },
          1350: {
            items: 3,
          },
        },
      });
    }
  }
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";
    return (
      <>
        <section className="feature-three-sec clearfix">
          <div
            className="feature-three__bg"
            style={{
              backgroundImage:
                "url(" +
                publicUrl +
                "assets/images/services/Steps/steps-garden.webp)",
            }}
          ></div>
          <div className="container">
            <div className="row">
              <div className="col-xl-12">
                <div className="feature-three__title">
                  <div className="sec-title">
                    <div className="sec-title__tagline">
                      <h6>About Us</h6> <span className="right"></span>
                    </div>
                    <h2 className="sec-title__title">
                      Stonehenge Masonry and Construction: About Us
                    </h2>
                    <p className="sec-title__text">
                      Building strong, reliable, and beautiful structures,
                      exceeding expectations.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-xl-12">
                <div className="feature-three__tab tabs-box">
                  <div className="feature-three__tab-button">
                    <ul className="tab-buttons clearfix">
                      <li data-tab="#history" className="tab-btn active-btn">
                        <h3>Our History</h3>
                      </li>
                      <li data-tab="#mission" className="tab-btn">
                        <h3>Our Mission</h3>
                      </li>
                      <li data-tab="#vision" className="tab-btn">
                        <h3>Our Vision</h3>
                      </li>
                    </ul>
                  </div>

                  <div className="tabs-content">
                    {/* Start Tab */}
                    <div className="tab active-tab" id="history">
                      <div className="feature-three__tab-content-item">
                        <div className="tab-content-inner">
                          <div className="row">
                            <div className="col-xl-5 col-lg-6">
                              <div className="tab-content-inner-text w-full">
                                <h2>Our History</h2>
                                <p>
                                  At Stonehenge Masonry and Construction, we are
                                  a family - owned business company with over 20
                                  years of experience building strong, reliable,
                                  and beautiful structures. With a passion for
                                  quality craftsmanship and attention to detail,
                                  we take pride in every project we undertake.
                                  Our team brings decades of expertise to both
                                  residential and commercial builds, ensuring
                                  that each job is completed with the utmost
                                  care, skill, and precision. We value trust and
                                  integrity, and we’re committed to providing
                                  personalized, professional service that
                                  exceeds expectations. From new constructions
                                  to restorations, we’re here to turn your
                                  vision into reality.
                                </p>
                              </div>
                            </div>
                            <div className="col-xl-7 col-lg-6">
                              <div style={{ maxWidth: "fit-content" }}>
                                <img
                                  src={
                                    publicUrl +
                                    "assets/images/services/lareira.webp"
                                  }
                                  className="rounded-md overflow-hidden"
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* End Tab */}

                    {/* Start Tab */}
                    <div className="tab" id="mission">
                      <div className="feature-three__tab-content-item">
                        <div className="tab-content-inner">
                          <div className="row">
                            <div className="col-xl-5 col-lg-6">
                              <div className="tab-content-inner-text">
                                <h2>Our Mission</h2>
                                <p>
                                  Our mission at Stonehenge Masonry and
                                  Construction is to deliver exceptional
                                  construction services with a focus on quality
                                  craftsmanship, meticulous attention to detail,
                                  and enduring durability for both residential
                                  and commercial projects. We strive to build
                                  strong, reliable, and beautiful structures,
                                  consistently exceeding client expectations
                                  through personalized, professional service.
                                  Upholding trust and integrity in every
                                  interaction, we offer a service that reflects
                                  decades of expertise and unwavering
                                  commitment..
                                </p>
                              </div>
                            </div>
                            <div className="col-xl-7 col-lg-6">
                              <div className="tab-content-inner-img">
                                <img
                                  src={
                                    publicUrl +
                                    "assets/images/services/fireplaces/fireplace.webp"
                                  }
                                  className="rounded-md overflow-hidden"
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* End Tab */}

                    {/* Start Tab */}
                    <div className="tab" id="vision">
                      <div className="feature-three__tab-content-item">
                        <div className="tab-content-inner">
                          <div className="row">
                            <div className="col-xl-5 col-lg-6">
                              <div className="tab-content-inner-text">
                                <h2>Our Vision</h2>
                                <p>
                                  Stonehenge Masonry and Construction envisions
                                  becoming a leading benchmark in the
                                  construction industry, renowned for our
                                  unwavering commitment to quality, reliability,
                                  and client satisfaction. We aspire to
                                  continually grow and evolve, preserving our
                                  family values and dedication to tradition,
                                  while embracing new technologies and evolving
                                  market demands. Ultimately, we aim to be the
                                  premier choice for clients seeking to build or
                                  restore their projects, transforming their
                                  visions into reality with mastery and
                                  dedication.
                                </p>
                              </div>
                            </div>
                            <div className="col-xl-7 col-lg-6">
                              <div className="tab-content-inner-img">
                                <img
                                  src={
                                    publicUrl +
                                    "assets/images/services/Steps/steps-garden.webp"
                                  }
                                  className="rounded-md overflow-hidden"
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* End Tab */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}
